// extracted by mini-css-extract-plugin
module.exports = {"card":"ra-card-cta_card__E61ER"};